import React from 'react';
import HeadingGroupBlock from './components/HeadingGroupBlock';
import InlineStyleGroupBlock from './components/InlineStyleGroupBlock';
import ListGroupBlock from './components/ListGroupBlock';
import LinkBlock from './components/LinkBlock';
import PhoneLinkBlock from './components/PhoneLinkBlock';
import { toolbarBlockNames as blockNames } from '../../config';

const blocks = {
  [blockNames.heading]: HeadingGroupBlock,
  [blockNames.inlineStyle]: InlineStyleGroupBlock,
  [blockNames.list]: ListGroupBlock,
  [blockNames.link]: LinkBlock,
  [blockNames.phoneLink]: PhoneLinkBlock,
};

const ToolbarBlock = ({ name }) => {
  const Component = blocks[name];
  return Component ? <Component /> : null;
};

export default ToolbarBlock;
